import * as React from 'react';
import { PageContainer } from '../common/Scaffolding/PageContainer';

export const ETrainingResources = () => {
  return <PageContainer title="E-Training Resources">TBA</PageContainer>;
};

export default ETrainingResources;
